module.exports = __webpack_public_path__ + "img/vgwoerrstadt.bb66d62f.svg";